// Προϊόντα που το Google Merchant απορρίπτει λόγω πολιτικής "Προϊόντα
// καπνού και σχετικός εξοπλισμός" (τσιγαριλίκια, φίλτρα, χαρτάκια,
// αναπτήρες, σταχτοδοχεία, ναργιλέδες, e-cigs κ.λπ.).
//
// Τα ps_id εδώ:
//  - εξαιρούνται από το merchant-feed & local-inventory-feed
//  - εξαιρούνται από το sitemap.xml
//  - παίρνουν noindex,follow στη σελίδα προϊόντος (χωρίς Product JSON-LD)
//
// Ενημέρωσε τη λίστα όταν το Merchant Center φλαγκάρει νέα προϊόντα.
export const TOBACCO_RELATED_PS_IDS: ReadonlySet<number> = new Set<number>([
  69532, 69976, 69688, 70024, 69969,
]);

export function isRestricted(psId: number | null | undefined): boolean {
  return psId != null && TOBACCO_RELATED_PS_IDS.has(Number(psId));
}